export * from './src/ng2-page-scroll.directive';
export * from './src/ng2-page-scroll.service';
export * from './src/ng2-page-scroll-config';
export * from './src/ng2-page-scroll-instance';
export * from './src/ng2-page-scroll-util.service';
export * from './src/ng2-page-scroll.module';

